import { DEFAULT_CARD_FIELD_STATES } from 'payments/constants/card';
import { COMMERCE_HUB_URL } from 'payments/constants/commerceHub';
import { initCommerceHub } from 'payments/helpers/commerceHub';
import { loadPaymentProviderScript } from 'payments/helpers/loadPaymentProviderScript';
import { type CardFieldStates } from 'payments/types/card';
import {
  CommerceHubPaymentForm,
  PaymentFormSubmitParams
} from 'payments/types/commerceHub';
import { useEffect, useState } from 'react';

import { isServer } from 'utility/isServer';

const useCommerceHub = () => {
  const [loadedCommerceHub, setLoadedCommerceHub] = useState(!!window.fiserv);
  const [paymentForm, setPaymentForm] = useState<CommerceHubPaymentForm | null>(
    null
  );
  const [cardFieldStates, setCardFieldStates] = useState<CardFieldStates>(
    DEFAULT_CARD_FIELD_STATES
  );

  const onLoad = () => setLoadedCommerceHub(true);

  useEffect(() => {
    if (!isServer() && !loadedCommerceHub) {
      loadPaymentProviderScript(COMMERCE_HUB_URL, onLoad);
    }
  }, []);

  useEffect(() => {
    if (loadedCommerceHub) {
      initCommerceHub(setCardFieldStates)
        .then(setPaymentForm)
        .catch(error => {
          console.error(
            `commerce hub: payment iframe failed to load: ${error}`
          );
        });
    }
  }, [loadedCommerceHub]);

  const handleCardSubmit = ({
    apiKey,
    accessToken,
    publicKey,
    merchantId,
    terminalId,
    keyId
  }: PaymentFormSubmitParams): Promise<any> | null => {
    let submission = null;

    if (paymentForm) {
      try {
        submission = paymentForm.submit({
          apiKey,
          accessToken,
          publicKey,
          merchantId,
          terminalId,
          keyId
        });
      } catch (error: any) {
        console.error(error.toString());
        throw new Error(
          'Unable to submit CommerceHub form data for card capture'
        );
      }
    }

    return submission;
  };

  return {
    handleCardSubmit,
    cardFieldStates,
    paymentForm
  };
};

export default useCommerceHub;
